import { ethers } from "ethers";
import abi from "./GlobalPool.json";

const Buy5 = ({ state }) => {
  const buyChai = async (event) => {
    event.preventDefault();
    const { contract } = state;
    const contractABI = abi.abi;
    var name = document.querySelector("#pp").value;
    const refer = document.querySelector("#hid").value;
    const addr = document.querySelector("#us").value;
    console.log(name, contract);
    console.log(refer);
   
    function refreshPage() {
      window.location.reload(false);
    }
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    
      const addressOfYourContract = '0x1f4bb39a2859c25be6884f6990aacf1506d448f3';
    const busdContractAddress = '0x20D4d44F3030556001664e7a1b3Abe21F713014B';
    const busdContractAbi = `[{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"balances","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"}]`;


    const busdContract = new ethers.Contract(busdContractAddress, busdContractAbi, signer);
    
    const amountToApprove = ethers.utils.parseUnits('2560', 18);
    const allowance = await busdContract.allowance(signer.getAddress(), addressOfYourContract);
    if (allowance.lt(amountToApprove)) {
      const tx = await busdContract.approve(addressOfYourContract, amountToApprove, {
        gasLimit: 75000,
    });
      await tx.wait();
    }
    
   
    const transaction = await contract.reinvest(addr,1, {
          gasLimit: 900000,
      });
    await transaction.wait();
    
    console.log("Transaction is done");
  
    
    refreshPage();
  };
  return (
    <>
      <div className="container-md" style={{ width: "100%", marginTop: "1px" }}>
        <form onSubmit={buyChai}>
        
          <button
            type="submit"
            id="sample"
             className="btn-action-pink"
           
          >
            Reinvest
          </button>
        </form>
      </div>
    </>
  );
};
export default Buy5;